import React from "react";
import { Link, useParams } from "react-router";
import { useSelector } from "react-redux";
import { Paper } from "@mui/material";
import appConfig from "../config";
import { LeasesBasicDetails, LeasesNav } from "../lease_management/elements";
import AccessDeniedMessage from "../lease_management/elements/AccessDeniedMessage";
import SettingNav from "../lease_management/elements/SettingNav";

const RoleBaseAccess = (OriginalComponent, extraProps) => {
    // const { permission } = useSelector((state) => state.leases);
    const NewComponent = (props) => {
        const { permission ,} = useSelector((state) => state.leases);
        const params = useParams();
        const parentPermission = permission?.permissions?.lease_revamp_application?.[extraProps.application]?.[extraProps.feature];
        const featurePermissionn = typeof extraProps.operationType === 'function' ? extraProps.operationType(params, props) : extraProps.operationType;
        const hasLeaseRevampAccess = !!permission?.permissions?.lease_revamp_application && Object.keys(permission.permissions.lease_revamp_application).length > 0
        if (featurePermissionn?.some(element => parentPermission?.includes(element))) {
            return <OriginalComponent {...props} />
        } else if (extraProps.leaseNav) {
            return (
                <>
                    <LeasesBasicDetails />
                    <Paper className='lease-details-section lease-nav-module-margin' elevation={0} sx={{ boxShadow: "0px 0px 2px 1px #BBBBBB" }}>
                        <LeasesNav />
                        <div className='lease-details-content'>
                            <AccessDeniedMessage />
                        </div>
                    </Paper>
                </>
            )
        } else if (extraProps.settingNav) {
            return (
                <Paper className="setting_details_section lease-details-section" elevation={0} sx={{ boxShadow: "0px 0px 2px 1px #BBBBBB" }}>
                    <SettingNav />
                    <div className='lease-details-content'>
                        <AccessDeniedMessage />
                    </div>
                </Paper>
            )
        } else {
            return (
                <div style={{ width: '100vw', height: '100vh', position: 'fixed' }}>
                    <div style={{
                        position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', color: '#000000',
                        textAlign: 'center', margin: '0 auto'
                    }}>
                        <br /><br />
                        Sorry, You do not have access to this page.<br />
                        Please contact Acumen for access.<br />
                        {hasLeaseRevampAccess? <Link to="/leases"> Go Back</Link>: <a href={appConfig.domain.subDomian}  rel="noopener noreferrer">Go Back</a>}
                    </div>
                </div>
            )
        }

    };
    return NewComponent;
};
export default RoleBaseAccess;

